export const routes = (prefix) => [
    {
        path: `/${prefix}/visit`,
        name: `${prefix}.visit.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.visit.index`,
                PageDescription: "Visit Listing",
            }
        }
    },
    {
        path: `/${prefix}/visit/create/:id`,
        name: `${prefix}.visit.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.visit.create`,
                PageDescription: "Create Visit",
            }
        }
    },
];
